import classNames from 'classnames';
import React from 'react';
import CreateList from './inputs/create-list';
import EndSlide from './inputs/end-slide';
import InformationSlide from './inputs/information-slide';
import MultipleChoiceList from './inputs/multiple-choice';
import TextAreaSlide from './inputs/text-area-slide';
import Trackbar from './inputs/trackbar';
import LetterSlideLabelTooltip from './labelTooltip';

const LetterSlide = ({
  content,
  popoverText,
  popoverBtnText,
  letterData,
  setLetterData,
  updateLetterData,
  finalOutputKey,
}) => {
  const inputComponent = () => {
    const blockIdentifier = `${content?.BlockTypeName}-${content?.BlockId}`;
    const endSlideKey = `${finalOutputKey}-${content?.BlockId}`;
    switch (content?.BlockTypeName) {
      case 'TrackbarSlide':
        return (
          <Trackbar
            key={blockIdentifier}
            autoFocus
            initialValue={letterData[blockIdentifier]?.value || 1}
            onUpdate={(updatedValue) =>
              updateLetterData(blockIdentifier, content?.Heading, updatedValue)
            }
          />
        );
      case 'ListCreationSlide':
        return (
          <CreateList
            key={blockIdentifier}
            setLetterData={setLetterData}
            initialData={letterData[blockIdentifier]?.value || []}
            onUpdate={(updatedValue) =>
              updateLetterData(blockIdentifier, content?.Heading, updatedValue)
            }
          />
        );
      case 'MultipleChoiceSlide':
        return (
          <MultipleChoiceList
            key={blockIdentifier}
            initialData={
              letterData[blockIdentifier]?.value ||
              content?.DefaultAnswerAlternatives?.map((item) => ({
                value: item.Value,
                checked: item.Checked,
                isDefault: true,
              }))
            }
            onUpdate={(updatedValue) =>
              updateLetterData(blockIdentifier, content?.Heading, updatedValue)
            }
          />
        );
      case 'TextAreaInputSlide':
        return (
          <TextAreaSlide
            key={blockIdentifier}
            label={content?.TextAreaSlideLabel}
            initialData={letterData[blockIdentifier]?.value || ''}
            onUpdate={(updatedValue) =>
              updateLetterData(blockIdentifier, content?.Heading, updatedValue)
            }
          />
        );
      case 'EndSlide':
        return (
          <EndSlide
            key={blockIdentifier}
            letterData={Object.fromEntries(
              Object.entries(letterData).filter(
                ([key]) => !key.startsWith(finalOutputKey)
              )
            )}
            label={content?.EndingSlideLabel}
            heading={content?.Heading}
            onUpdate={(updatedValue) =>
              updateLetterData(endSlideKey, '', updatedValue)
            }
          />
        );
    }
  };

  if (!content) return null;

  if (content?.BlockTypeName === 'InformationSlide') {
    return (
      <InformationSlide
        heading={content?.Heading}
        text={content?.Text}
        tooltipButtontext={popoverBtnText}
        tooltipText={popoverText}
        imageUrl={content?.Image?.[0]?.ImageUrl}
        imageDescription={content?.Image?.[0]?.ImageDescription}
      />
    );
  }

  return (
    <div
      className={classNames({
        'c-letter-slide': true,
        'c-letter-slide__information-slide':
          content?.BlockTypeName === 'InformationSlide',
        'c-letter-slide--end-slide': content?.BlockTypeName === 'EndSlide',
      })}
    >
      <h2 className="c-letter-slide__heading">{content?.Heading}</h2>

      <div
        className={classNames({
          'c-letter-slide__scrollable': true,
        })}
      >
        <div className="c-letter-slide--top">
          <p className="c-letter-slide--top__text">{content?.Text}</p>
          <LetterSlideLabelTooltip
            key={content?.BlockTypeName}
            tooltipLinkText={popoverBtnText}
            tooltipText={popoverText}
          />
        </div>
        <div className="c-letter-slide__input">{inputComponent()}</div>
      </div>
    </div>
  );
};

export default LetterSlide;
